// ============================================================================
// CONFIG CENTRAL — Templo | Jiu-Jitsu Culture (Savassi/BH)
// ============================================================================
import aboutImg from "../assets/sobre-templo-bh.jpg";
import profRafael from "../assets/prof-rafael-machado.jpg";
import profVictor from "../assets/prof-victor-moreira.jpg";
import profMaria from "../assets/prof-maria-clara.jpg";

export const SITE = {
  brand: "Templo",
  brandFull: "Templo | Jiu-Jitsu Culture",
  tagline: "Jiu-jitsu para a vida real",
  city: "Savassi, Belo Horizonte/MG",
  instagram: "templo_bh",
  instagramUrl: "https://instagram.com/templo_bh",
  whatsapp: "5531983833736",
  opening: "15/08/2026",
  classesStart: "17/08/2026",
  kimonoSpots: 50,
  address: "Rua Alagoas, 1160 — 2º andar, Savassi, Belo Horizonte/MG",
  mapsEmbed:
    "https://www.google.com/maps?q=Rua+Alagoas,+1160,+Savassi,+Belo+Horizonte+-+MG&output=embed",
  mapsDirections:
    "https://www.google.com/maps/dir/?api=1&destination=Rua+Alagoas,+1160,+Savassi,+Belo+Horizonte+-+MG",
};

export const waLink = (message) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(message)}`;

export const ABOUT_PARAGRAPHS = [
  "Na TEMPLO BH, acreditamos que o jiu-jitsu vai muito além das técnicas, das graduações e das medalhas. Ele é uma ferramenta de transformação capaz de desenvolver disciplina, confiança, respeito e equilíbrio para a vida. Nossa missão é oferecer uma experiência que une excelência técnica, acolhimento e desenvolvimento humano. Queremos que cada aluno encontre aqui um ambiente seguro para evoluir, independentemente da idade, da experiência ou do objetivo.",
  "A TEMPLO BH nasce inspirada em uma filosofia que valoriza pessoas antes de atletas. Acreditamos que o verdadeiro crescimento acontece quando o aprendizado do tatame ultrapassa seus limites e passa a fazer parte da rotina, das relações e das decisões da vida.",
  "Esse propósito é representado pelos três sócios da unidade.",
  "Lívia construiu uma carreira de mais de dez anos no Direito, mas decidiu seguir um caminho alinhado ao seu propósito. Ao deixar a advocacia para se dedicar à TEMPLO BH, escolheu investir em um projeto que acredita no poder do esporte para transformar vidas e fortalecer pessoas.",
  "Rafael Machado, engenheiro, administrador e faixa-preta 2º grau, pratica jiu-jitsu há mais de 25 anos e leciona há mais de 15 anos. Sua trajetória como atleta, professor e líder sempre foi guiada pela convicção de que ensinar jiu-jitsu é, acima de tudo, formar pessoas.",
  "Victor, economista e faixa-preta de jiu-jitsu, une sua visão estratégica de gestão à experiência no tatame. Sua atuação contribui para que a TEMPLO BH seja construída sobre bases sólidas, com organização, profissionalismo e uma cultura voltada para a excelência.",
  "Juntos, eles compartilham a mesma visão: criar muito mais do que uma academia. Um espaço onde pessoas sejam acolhidas, desafiadas e incentivadas a crescer todos os dias.",
  "Aqui, cada aula é planejada para desenvolver técnica, disciplina e confiança. Valorizamos o respeito, a humildade, a parceria e o senso de comunidade, porque acreditamos que a evolução individual acontece em um ambiente construído coletivamente.",
  "A TEMPLO BH é um lugar para quem deseja aprender, superar limites, cuidar da saúde, fazer amizades e levar os ensinamentos do jiu-jitsu para além do tatame. Porque o verdadeiro significado da faixa não está apenas na graduação que se conquista. Está na pessoa que você se torna durante essa jornada.",
];
export const ABOUT_CLOSING = "Bem-vindo à TEMPLO BH. Um lugar para evoluir dentro e fora do tatame.";

export const TURMAS_INTRO =
  "Na TEMPLO BH, acreditamos que cada aluno possui um objetivo diferente. Por isso, nossas turmas são organizadas para proporcionar uma evolução segura, técnica e respeitando o momento de cada praticante.";

export const TURMAS = [
  { title: "Jiu-Jitsu Infantil", tag: "5 a 10 anos", desc: "As aulas infantis desenvolvem muito mais do que técnicas de defesa pessoal. Trabalhamos disciplina, respeito, coordenação motora, concentração e autoconfiança por meio de atividades lúdicas e um método de ensino pensado para crianças. O objetivo é formar pessoas melhores enquanto elas aprendem jiu-jitsu de maneira divertida e segura." },
  { title: "Jiu-Jitsu Juvenil", tag: "11 a 15 anos", desc: "Na adolescência, o esporte se torna uma poderosa ferramenta para desenvolver responsabilidade, disciplina e inteligência emocional. As aulas são voltadas para o aperfeiçoamento técnico, preparação física e fortalecimento da confiança, sempre em um ambiente saudável e respeitoso." },
  { title: "Jiu-Jitsu Iniciante", tag: "", desc: "Nunca treinou jiu-jitsu? Esta turma foi criada para você. Aqui o aluno aprende desde os fundamentos básicos, posições, movimentações e conceitos da modalidade, em um ambiente acolhedor e sem pressão. O foco é proporcionar uma evolução consistente para que qualquer pessoa possa iniciar sua jornada com segurança e confiança." },
  { title: "Jiu-Jitsu Intermediário", tag: "", desc: "Destinada aos alunos que já dominam os fundamentos e desejam ampliar seu repertório técnico. As aulas possuem maior volume de técnicas, combinações e situações específicas de luta, preparando o praticante para um nível mais elevado." },
  { title: "Jiu-Jitsu Avançado", tag: "", desc: "Voltada para graduados e praticantes experientes. As aulas apresentam um alto nível técnico, estratégias de competição, refinamento de detalhes e treinos intensos para quem busca constante evolução." },
  { title: "Jiu-Jitsu Feminino", tag: "", desc: "Um ambiente pensado para que mulheres possam aprender jiu-jitsu com confiança, acolhimento e evolução técnica. Seja para defesa pessoal, qualidade de vida, esporte ou desenvolvimento pessoal, as aulas são conduzidas respeitando o ritmo de cada aluna." },
  { title: "NOGI", tag: "sem kimono", desc: "O NOGI é o jiu-jitsu praticado sem kimono. As aulas desenvolvem velocidade, movimentação, controle corporal e técnicas específicas dessa modalidade, sendo uma excelente opção para quem deseja ampliar seu repertório técnico. Há turmas para iniciantes, intermediários, avançados e também uma turma exclusiva feminina." },
  { title: "Master 40+", tag: "", desc: "Porque a evolução não tem idade. As aulas Master foram desenvolvidas para praticantes acima dos 40 anos, respeitando as características físicas dessa fase da vida, com treinos inteligentes, seguros e tecnicamente desafiadores." },
  { title: "Drills", tag: "", desc: "Treinos focados na repetição de movimentos específicos para desenvolver memória muscular, velocidade, precisão e eficiência técnica. Perfeito para acelerar a evolução no jiu-jitsu." },
  { title: "Muay Thai", tag: "", desc: "Além do jiu-jitsu, oferecemos aulas de Muay Thai para quem busca melhorar o condicionamento físico, desenvolver técnicas de luta em pé e complementar seus treinamentos." },
  { title: "Boxe", tag: "", desc: "As aulas de Boxe desenvolvem coordenação, velocidade, potência, resistência e preparo cardiovascular, sendo uma excelente opção tanto para condicionamento quanto para quem deseja aprender a modalidade." },
  { title: "Preparação Física", tag: "", desc: "Treinos específicos para aumentar força, potência, resistência e prevenir lesões. Um complemento ideal para melhorar o desempenho no jiu-jitsu e em outras modalidades esportivas." },
  { title: "Flexibilidade e Alongamento", tag: "", desc: "Mobilidade também é performance. Essas aulas ajudam a melhorar amplitude de movimento, reduzir dores musculares, prevenir lesões e favorecer a recuperação entre os treinos." },
];

// Grade de horários — 3 tatames (Tatame 1 grande, 2 e 3 menores).
// Célula vazia = "". Cada dia é um "slide" do carrossel.
export const SCHEDULE_DAYS = [
  { day: "Segunda", rows: [
    { time: "6h30 – 7h20", t1: "", t2: "Jiu-Jitsu Feminino", t3: "Jiu-Jitsu Iniciante" },
    { time: "7h – 7h50", t1: "Jiu-Jitsu Interm. e Avançado · Prof. Rafael Machado", t2: "", t3: "Boxe" },
    { time: "10h – 10h50", t1: "Jiu-Jitsu Kids (5–10)", t2: "Flexibilidade & Alongamento", t3: "" },
    { time: "12h – 12h50", t1: "Jiu-Jitsu Adulto All Levels · Prof. Rafael Machado", t2: "", t3: "" },
    { time: "17h – 17h50", t1: "Jiu-Jitsu Juvenil (11–15)", t2: "", t3: "" },
    { time: "18h – 18h50", t1: "Jiu-Jitsu Intermediário · Prof. Rafael Machado", t2: "Jiu-Jitsu Feminino", t3: "Jiu-Jitsu Kids (5–10)" },
    { time: "19h – 19h50", t1: "Jiu-Jitsu Avançado · Prof. Rafael Machado", t2: "Jiu-Jitsu Iniciante", t3: "Boxe" },
    { time: "20h – 20h50", t1: "Jiu-Jitsu Master 40+", t2: "Preparação Física (funcional)", t3: "" },
  ]},
  { day: "Terça", rows: [
    { time: "6h30 – 7h20", t1: "", t2: "Jiu-Jitsu Feminino", t3: "Jiu-Jitsu Iniciante" },
    { time: "7h – 7h50", t1: "Jiu-Jitsu Interm. e Avançado · Prof. Rafael Machado", t2: "", t3: "Preparação Física (funcional)" },
    { time: "10h – 10h50", t1: "Jiu-Jitsu Kids (5–10)", t2: "Flexibilidade & Alongamento", t3: "" },
    { time: "12h – 12h50", t1: "Jiu-Jitsu Adulto All Levels · Prof. Rafael Machado", t2: "", t3: "" },
    { time: "17h – 17h50", t1: "Jiu-Jitsu Juvenil (11–15)", t2: "", t3: "" },
    { time: "18h – 18h50", t1: "Jiu-Jitsu Intermediário · Prof. Rafael Machado", t2: "Jiu-Jitsu Feminino", t3: "Jiu-Jitsu Kids (5–10)" },
    { time: "19h – 19h50", t1: "Jiu-Jitsu Avançado · Prof. Rafael Machado", t2: "Jiu-Jitsu Iniciante", t3: "Muay Thai" },
    { time: "20h – 20h50", t1: "Jiu-Jitsu Drills", t2: "Flexibilidade & Alongamento", t3: "" },
  ]},
  { day: "Quarta", rows: [
    { time: "6h30 – 7h20", t1: "", t2: "NoGi Feminino", t3: "NoGi Iniciante" },
    { time: "7h – 7h50", t1: "NoGi Interm. e Avançado · Prof. Rafael Machado", t2: "", t3: "Boxe" },
    { time: "10h – 10h50", t1: "NoGi Kids (5–10)", t2: "Flexibilidade & Alongamento", t3: "" },
    { time: "12h – 12h50", t1: "NoGi Adulto All Levels · Prof. Rafael Machado", t2: "", t3: "" },
    { time: "17h – 17h50", t1: "NoGi Juvenil (11–15)", t2: "", t3: "" },
    { time: "18h – 18h50", t1: "NoGi Intermediário · Prof. Rafael Machado", t2: "NoGi Feminino", t3: "Jiu-Jitsu Kids (5–10)" },
    { time: "19h – 19h50", t1: "NoGi Avançado · Prof. Rafael Machado", t2: "NoGi Iniciante", t3: "Boxe" },
    { time: "20h – 20h50", t1: "NoGi Master 40+", t2: "Preparação Física (funcional)", t3: "" },
  ]},
  { day: "Quinta", rows: [
    { time: "6h30 – 7h20", t1: "", t2: "Jiu-Jitsu Feminino", t3: "Jiu-Jitsu Iniciante" },
    { time: "7h – 7h50", t1: "Jiu-Jitsu Interm. e Avançado · Prof. Rafael Machado", t2: "", t3: "Preparação Física (funcional)" },
    { time: "10h – 10h50", t1: "Jiu-Jitsu Kids (5–10)", t2: "Flexibilidade & Alongamento", t3: "" },
    { time: "12h – 12h50", t1: "Jiu-Jitsu Adulto All Levels · Prof. Rafael Machado", t2: "", t3: "" },
    { time: "17h – 17h50", t1: "Jiu-Jitsu Juvenil (11–15)", t2: "", t3: "" },
    { time: "18h – 18h50", t1: "Jiu-Jitsu Intermediário · Prof. Rafael Machado", t2: "Jiu-Jitsu Feminino", t3: "Jiu-Jitsu Kids (5–10)" },
    { time: "19h – 19h50", t1: "Jiu-Jitsu Avançado · Prof. Rafael Machado", t2: "Jiu-Jitsu Iniciante", t3: "Muay Thai" },
    { time: "20h – 20h50", t1: "Jiu-Jitsu Drills", t2: "Flexibilidade & Alongamento", t3: "" },
  ]},
  { day: "Sexta", rows: [
    { time: "6h30 – 7h20", t1: "", t2: "Jiu-Jitsu Feminino", t3: "Jiu-Jitsu Iniciante" },
    { time: "7h – 7h50", t1: "Jiu-Jitsu Interm. e Avançado · Prof. Rafael Machado", t2: "", t3: "Boxe" },
    { time: "10h – 10h50", t1: "Jiu-Jitsu Kids (5–10)", t2: "Flexibilidade & Alongamento", t3: "" },
    { time: "12h – 12h50", t1: "Jiu-Jitsu Adulto All Levels · Prof. Rafael Machado", t2: "", t3: "" },
    { time: "17h – 17h50", t1: "Jiu-Jitsu Juvenil (11–15)", t2: "", t3: "" },
    { time: "18h – 19h50", t1: "Jiu-Jitsu Open Mat · All Levels", t2: "", t3: "Jiu-Jitsu Kids (5–10)" },
  ]},
  { day: "Sábado", rows: [
    { time: "10h – 12h", t1: "Jiu-Jitsu Open Mat · All Levels", t2: "", t3: "" },
  ]},
];

export const PLANS = {
  grupo1: {
    title: "Grupo 1 — Jiu-Jitsu",
    tiers: [
      { name: "Adulto", plans: [
        { label: "Anual", price: "R$ 299", per: "/mês", best: true },
        { label: "Semestral", price: "R$ 349", per: "/mês", best: false },
        { label: "Mensal", price: "R$ 369", per: "/mês", best: false },
      ]},
      { name: "Infantil / Juvenil", plans: [
        { label: "Anual", price: "R$ 249", per: "/mês", best: true },
        { label: "Semestral", price: "R$ 299", per: "/mês", best: false },
        { label: "Mensal", price: "R$ 319", per: "/mês", best: false },
      ]},
    ],
    cta: "Quero o plano de Jiu-Jitsu",
    waMsg: "Oi! Quero saber mais sobre os planos de Jiu-Jitsu (Grupo 1) da Templo BH.",
  },
  grupo2: {
    title: "Grupo 2 — Boxe · Muay Thai · Preparação Física · Alongamento",
    tiers: [
      { name: "Adulto", plans: [
        { label: "Anual", price: "R$ 249", per: "/mês", best: true },
        { label: "Semestral", price: "R$ 269", per: "/mês", best: false },
        { label: "Mensal", price: "R$ 299", per: "/mês", best: false },
      ]},
    ],
    combo: {
      title: "Combo Jiu-Jitsu + Demais Modalidades",
      label: "Plano Anual",
      price: "R$ 423",
      per: "/mês",
      note: "50% de desconto no plano anual de menor valor · Acesso completo à academia",
    },
    cta: "Quero o combo completo",
    waMsg: "Oi! Quero saber mais sobre o Grupo 2 / combo completo da Templo BH.",
  },
};

export const PROFESSORES = [
  { name: "Rafael Machado", belt: "Faixa Preta 2º grau", img: profRafael },
  { name: "Victor Moreira", belt: "Faixa Preta", img: profVictor },
  { name: "Maria Clara", belt: "Faixa Roxa", img: profMaria },
];

export const INTERESSES = [
  "Jiu-Jitsu Adulto",
  "Jiu-Jitsu Kids",
  "Jiu-Jitsu Feminino",
  "NoGi",
  "Master 40+",
  "Muay Thai",
  "Boxe",
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1656653121475-e33829581294?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  about: aboutImg,
};

export const NAV_LINKS = [
  { label: "Sobre", href: "#sobre" },
  { label: "Turmas", href: "#turmas" },
  { label: "Horários", href: "#horarios" },
  { label: "Planos", href: "#planos" },
  { label: "Professores", href: "#professores" },
];
